// extracted by mini-css-extract-plugin
module.exports = {"ChartsContainer":"styles_ChartsContainer__12nKi","hasTab":"styles_hasTab__1ivjb"};